import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { queryTreeListForRole, queryRolePermission, saveRolePermission } from '@/api/api';
import RoleDataruleModal from "./RoleDataruleModal.vue";
export default {
  name: 'RoleModal',
  components: {
    RoleDataruleModal: RoleDataruleModal
  },
  data: function data() {
    return {
      roleId: '',
      treeData: [],
      defaultCheckedKeys: [],
      checkedKeys: [],
      expandedKeys: [],
      allTreeKeys: [],
      autoExpandParent: true,
      checkStrictly: false,
      title: '角色权限配置',
      visible: false,
      loading: false
    };
  },
  methods: {
    onTreeNodeSelect: function onTreeNodeSelect(id) {
      this.$refs.datarule.show(id[0], this.roleId);
    },
    onCheck: function onCheck(o) {
      console.log('onCheck', o);

      if (this.checkStrictly) {
        this.checkedKeys = o.checked;
      } else {
        this.checkedKeys = o;
      }
    },
    show: function show(roleId) {
      this.roleId = roleId;
      this.visible = true;
    },
    close: function close() {
      this.reset();
      this.$emit('close');
      this.visible = false;
    },
    onExpand: function onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    reset: function reset() {
      this.expandedKeys = [];
      this.checkedKeys = [];
      this.defaultCheckedKeys = [];
      this.loading = false;
    },
    expandAll: function expandAll() {
      this.expandedKeys = this.allTreeKeys;
    },
    closeAll: function closeAll() {
      this.expandedKeys = [];
    },
    checkALL: function checkALL() {
      this.checkedKeys = this.allTreeKeys;
    },
    cancelCheckALL: function cancelCheckALL() {
      //this.checkedKeys = this.defaultCheckedKeys
      this.checkedKeys = [];
    },
    switchCheckStrictly: function switchCheckStrictly(v) {
      if (v == 1) {
        this.checkStrictly = false;
      } else if (v == 2) {
        this.checkStrictly = true;
      }
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    handleSubmit: function handleSubmit() {
      var that = this;
      var params = {
        roleId: that.roleId,
        permissionIds: that.checkedKeys.join(','),
        lastpermissionIds: that.defaultCheckedKeys.join(',')
      };
      that.loading = true;
      console.log('请求参数：', params);
      saveRolePermission(params).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loading = false;
          that.close();
        } else {
          that.$message.error(res.message);
          that.loading = false;
        }
      });
    }
  },
  watch: {
    visible: function visible() {
      var _this = this;

      if (this.visible) {
        queryTreeListForRole().then(function (res) {
          _this.treeData = res.result.treeList;
          _this.allTreeKeys = res.result.ids.map(String);
          console.log('allTreeKeys', _this.allTreeKeys);
          queryRolePermission({
            roleId: _this.roleId
          }).then(function (res) {
            _this.checkedKeys = _toConsumableArray(res.result).map(String);
            _this.defaultCheckedKeys = _toConsumableArray(res.result).map(String);
            _this.expandedKeys = _this.allTreeKeys;
          });
        });
      }
    }
  }
};